import { Text } from '@moda/om';
import React, { useCallback, useMemo } from 'react';
import { MobileSiteNavOption } from '../../MobileSiteNavOption';
import { tc } from '../../../../lib/trackingContext';

interface Props {
  label: string;
  url: string;
  onClick: () => void;
}

export const RefreshedMobileSiteNavMenuLinkItem: React.FC<Props> = ({ url, label, onClick }) => {
  const href = useMemo(() => {
    if (!url) return null;

    try {
      // we can log this -- here the url looks like https://modaoperandi.com/clothing/etc and it should be strict pathname
      return new URL(url).pathname;
    } catch (error) {
      return url;
    }
  }, [url]);

  const handleTrackMobileNavItemClicked = useCallback((url: string | null, text: string | null) => {
    tc.track('Mobile Navigation Item Clicked', {
      addToTrackingEvent: {
        url,
        text,
        label: text
      }
    });
  }, []);

  return (
    <>
      <MobileSiteNavOption
        href={href}
        onClick={() => {
          onClick();
          handleTrackMobileNavItemClicked(href, label);
        }}
      >
        <Text>{label}</Text>
      </MobileSiteNavOption>
    </>
  );
};
